import { render, staticRenderFns } from "./OpportunityResourceDetail.vue?vue&type=template&id=048af001&"
import script from "./OpportunityResourceDetail.vue?vue&type=script&lang=js&"
export * from "./OpportunityResourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityResourceDetail.vue?vue&type=style&index=0&id=048af001&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports